// extracted by mini-css-extract-plugin
export default {"b":"row1_b__0Fequ","l":"row1_l__ke-j8","details":"row1_details__Xlb7e","h":"row1_h__-gFgk","s":"row1_s__Z1RpF","r":"row1_r__GIN71","tx":"row1_tx__U1j5+","icon":"row1_icon__37+ij"};